import React, { useEffect, useRef, useState } from 'react';
import { ResponsiveContainer } from 'recharts';

/**
 * Wraps a recharts chart in a self-measuring box that only renders the chart once it has a
 * positive measured width, then hands recharts an explicit numeric width/height.
 *
 * This avoids recharts v3's noisy "The width(-1) and height(-1) of chart should be greater
 * than 0" warning, which fires when ResponsiveContainer measures a flex/grid parent before
 * layout has settled.
 */
export default function ChartBox({ height = 300, children }) {
  const ref = useRef(null);
  const [width, setWidth] = useState(0);

  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const ro = new ResizeObserver((entries) => {
      const w = entries[0]?.contentRect?.width ?? 0;
      if (w > 0) setWidth(w);
    });
    ro.observe(el);
    return () => ro.disconnect();
  }, []);

  return (
    <div ref={ref} style={{ width: '100%', height }}>
      {width > 0 && (
        <ResponsiveContainer width={width} height={height}>
          {children}
        </ResponsiveContainer>
      )}
    </div>
  );
}
